export default "__VITE_ASSET__CfdxrV22__"